



import React, {Component} from 'react'

const formatter = require('../../../../utils/formatter/formatter.js');
const stringUtil = require('../../../../utils/string/stringUtil.js');
const translator = require('../../../../utils/translator/translator.js');

class CategoryItemWithoutImage extends Component 
{
    render()
    {
        var backgroundColor = this.props.item.backgroundColor;
        var foreColor = this.props.item.foregroundColor;

        if (stringUtil.isStringNullOrEmpty(backgroundColor))
            backgroundColor = this.props.category.backgroundColor;
        if (stringUtil.isStringNullOrEmpty(foreColor))
            foreColor = this.props.category.foregroundColor;

        if (stringUtil.isStringNullOrEmpty(backgroundColor))
            backgroundColor = '#686868';
        if (stringUtil.isStringNullOrEmpty(foreColor))
            foreColor = "#F0F0F0";

        if (this.props.snoozed || !this.props.enabled)
        {
            backgroundColor = '#E8E8E8';
            foreColor = "#808080";
        }

        return <div style={{
                                display:'flex',
                                flexDirection:'column',
                                justifyContent:'space-between',
                                border:'1px solid #00000020', 
                                minWidth:"calc(25% - 3px)",
                                maxWidth:"calc(25% - 3px)",
                                flex: '1 1 0px',
                                gap:"4vh",
                                padding:'8px',
                                background:backgroundColor, color:foreColor,
                                borderRadius:"var(--button-roundness)",
                                overflow:'hidden',
                                boxShadow: "0 0 12px var(--colors-primary20)",
                               }}
                    onClick={this.props.onClick}>
                   
                        {this.renderMenuItemTitle(this.props.item)}
                        {this.renderMenuItemPrice(this.props.item)}
               </div>
    }

    renderMenuItemTitle(item)
    {
        var caption = <div style={{
            textAlign:'left',
            fontWeight:'bold',
            lineHeight:1.3

           }}>{item.caption}</div>;
        if (this.props.snoozed)
            caption = <div>
                        <div>{item.caption}</div>
                        <div>{translator.getLabel("out_Of_stock")}</div>
                      </div>

        return caption;
    }

    renderMenuItemPrice(item)
    {
        var priceLabel = "N/A";

        if (item.price != null)
        {
            priceLabel = formatter.convertToCurrencyFormat(item.price);
        }

        return (<div style={{marginTop:'10px', fontSize:"1.2rem", fontWeight:'normal'}}>{priceLabel}</div>);
    }
}

export default CategoryItemWithoutImage